package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_09_27_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At 4pm our heroes receive word to expect Lady Aventary to be joined by her husband, Elrovir Rodiridan.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes learn that the Duke of Brij has not been seen recently in Brij, which is odd because he is normally a public figure. Amusingly, the heroes discuss how the massive Bridge is not actually in Brij but rather is just outside Brij. The Bridge’s security is handled by the Malusian guard and not the local Brij guard or militias.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At dinner, our heroes meet Elrovir Rodiridan, a handsome, tall (6’9”) wood elf. He is a skilled tracker, hunter, and archer originally from the Girolion Forest in the distant island of Ostvel across the Sea of Indifference. Lady Aventary is from Kalladāga in the Bardifroth region. The couple met in Freiburg after they were both recruited by The Peers. Freiburg is a very large city, which organically grew as a commercial hub due to the free trade made possible by the lack of a patrolling navy or state control. Elrovir and Aventary seem like an odd pairing to some, as Elrovir has the wild nature one might expect of a wood elf where Lady Aventary projects a noble upbringing.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lady Aventary wanted the heroes to meet Elrovir because he plans to teleport to Freiburg and then travel to Girolion Forest to begin the search for the shard of the Shield of Concar in that region.  Our heroes are to meet him at their convenience.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette fixes the cart. Tuesday speaks to Flower (the horse). Flower doesn’t like magical travel or caves. But does like apples and carrots.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes setup a night watch due to Florin’s heat from his old gang.")
    }
}
